import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import StrongGrowthDetails from "./components/StrongGrowthDetails";

export default function StrongGrowth() {
  return (
    <Layout>
      <NewsHeader>“A Strong Base for Growth” – EYDK Biennial Report</NewsHeader>
      <StrongGrowthDetails />
    </Layout>
  );
}
